<template>

      <div id="editor" class="editor_wrap"  >
        <div class="header_" >
          <div style="width:15%;cursor:pointer; ">
            <img   :src="require('@/assets/images/newlogo.png')"   width="134px" height="50px"  @click="BackToHome" >
             <!-- src="@/assets/images/newlogo.png"  -->
          </div>
           
          <div style="width:35%;font-size:28px;color:#dedede; ">  </div> 
          
          <div class="head_operation"  >
            <!-- <i v-if="mode=='drafts' || mode=='mine' " class="el-icon-edit"  @click="ModifyMyArticle" title="编辑"></i>
            <i v-if=" mode=='mine' "  class="el-icon-share" title="分享"></i>
            <i v-if="mode=='drafts' || mode=='mine' " class="el-icon-delete" @click="ConfirmDelete"   title="删除"></i>
 
            
            <el-button v-if="mode=='drafts' && article.isIssued!='yes'" type="primary" @click="IssueMyArticle"  style="width:100px;margin-left:50px">发布</el-button> -->

                      
          </div>
          
          <div v-if="!isMini" class="loginAvatar">
     
            <el-avatar v-if="!islogin" title="登录" :src="require('@/assets/images/touxiang.png')" style="margin-right:20px;cursor:pointer; " @error="errorHandler" @click.native="SignIn"  >
                  
            </el-avatar>

            <el-dropdown v-else >
        
              <el-avatar  :src="userInfo.avatarUrl" style="margin-right:20px;cursor:pointer" @error="errorHandler" >
                  <img :src="userInfo.avatarUrl"/>
              </el-avatar>
              <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="SignOut">退出登录</el-dropdown-item>

                  <el-dropdown-item  command="deposit"  @click.native="Turn2Charge" >
                  
                    <span class="iconfont"    >&#xe71b;</span>
                      充值({{$store.state.accountInfo.coins}})
                  </el-dropdown-item> 
                
              </el-dropdown-menu> 



            </el-dropdown>

          </div>

        
        </div>

        <div class="middle" :style="isphone? 'min-height:'+screenHeight*0.88+'px;width:'+screenWidth*0.98+'px;padding:5px;' :'min-height:'+screenHeight*0.88+'px' ">
          <div class="left"  v-if="!isphone"></div>
       
          <div class="mid_"  :style="isphone?'width:100%':''">
        
              
                  <input type="file" id="file" accept=".docx"/>
              
                <button @click="handlePreview">预览</button>
 

         
            <div    >
              <img src="@/assets/images/white_pic.png" alt="" id="hideimg" class="hideimg" > 

             

                <!-- <div   id='content_'   >  123 </div> -->

                <div id="bodyContainer"></div>

            </div>
          

   

            <!-- <div class="html_content"  v-resize="DomResize"  id='content_' v-html="doc"  :style="isphone? 'width:'+screenWidth*0.98+'px':''  "></div> -->

            <!-- <div  style="margin-top:30px; color:#909090;font-size:16px">编辑于 {{timestampToTime(article.updateTime)||'' }}</div> -->

            <div class="tagsBar">
              <span v-if="article.tags&&article.tags[0]  "><el-tag>{{article.tags[0]}}</el-tag></span> 
              <span v-if="article.tags&&article.tags[1]  "><el-tag type="success">{{article.tags[1]}}</el-tag></span> 
              <span v-if="article.tags&&article.tags[2]  "><el-tag type="warning">{{article.tags[2]}}</el-tag></span> 
            </div>            
            <div style="height:200px;"></div>
   
          </div>
          <div class="right" v-if="!isphone"></div>
























        </div>
       
 

        <el-dialog
          width="200px"
          title="微信扫一扫"
          @close="closeCode"
          :visible.sync="shareVisible"
          append-to-body>
          <div class="sharecode">
            <div id="qrcode" ref="qrcode"></div>
          </div>
        </el-dialog>

 
        
     
       
      </div>
  
     
</template>

<script>

import { defaultOptions, renderAsync } from "docx-preview";

 


 
import QRCode  from "qrcodejs2"
// import VueQArt from 'vue-qart'

// var wx = require('weixin-js-sdk');
import wx from 'weixin-js-sdk'
import axios from 'axios'
import saveAs from '@/assets/js/html2word/FileSaver.js'
import htmlDocx from '@/assets/js/html2word/html-docx.js'

import pako from '@/assets/js/compress/pako.js' 

var weixinJDK={}
weixinJDK.timestamp=Date.parse(new Date())/1000
weixinJDK.appId= 'wx5b2080a9450184a9'
weixinJDK.nonceStr=random_str(16)
// weixinJDK.jsApiList=['updateAppMessageShareData','updateTimelineShareData']

 

// wx.ready(function () {   
//   window.console.log('wx.showMenuItems():',wx.showMenuItems())

// });


function random_str(number){
  return Math.random().toString(36).substr(2).slice(1,number+1)
}

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

function getNum() {
  var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
      'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
      'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
      'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
      'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
      'x', 'y', 'z'];
  var nums = "";
  for (var i = 0; i < 8; i++) {
    var id = parseInt(Math.random() * 61);
    nums += chars[id];
  }
  return nums;

}

 

function handleCodePoints(array) {
    var CHUNK_SIZE = 0x8000; // arbitrary number here, not too small, not too big
    var index = 0;
    var length = array.length;
    var result = '';
    var slice;
    var arr = [];
    for (var i = 0, _i = array.length; i < _i; i++) {
        arr[i] = array[i];
    }
    while (index < length) {
        slice = arr.slice(index, Math.min(index + CHUNK_SIZE, length)); // `Math.min` is not really necessary here I think
        result += String.fromCharCode.apply(null, slice);
        index += CHUNK_SIZE;
    }
    return result;
}

function unzip(b64Data){
    var strData   = atob(b64Data);
    //  var strData   = atob(unescape(b64Data));
    //   var strData=btoa(unescape(encodeURIComponent(b64Data)))
    //   var strData = decodeURIComponent(escape(window.atob(b64Data)));
      // Convert binary string to character-number array
      var charData  = strData.split('').map(function(x){return x.charCodeAt(0);});
      // Turn number array into byte-array
      var binData   = new Uint8Array(charData);
      // // unzip
      var data    = pako.inflate(binData);
      // Convert gunzipped byteArray back to ascii string:
    //  strData   = String.fromCharCode.apply(null, new Uint16Array(data));
    strData=handleCodePoints(data)

     return strData
    //  console.log('strData:',strData)
    //  return decodeURIComponent(strData);
}



      

function b64toBlob(b64Data, contentType, sliceSize) {

    let b = b64Data.toString();

    b64Data = b.split(',')[1];

    var byteCharacters =atob(b64Data);

    var byteArrays = [];

    for (let offset =0; offset < byteCharacters.length; offset += sliceSize) {

        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers =new Array(slice.length);

        for (let i =0; i < slice.length; i++) {

            byteNumbers[i] = slice.charCodeAt(i);

        }

        var byteArray =new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);

    }

    var blob =new Blob(byteArrays, {type: contentType});

    return blob;

}
 

function blobToFile(theBlob,fileName) {

    theBlob.lastModifiedDate =new Date();

    theBlob.name = fileName;

    return theBlob;

}

function dataURLtoFile(dataurl, filename) { // 生成Blob
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
 


export default {
        name: 'article',
        // inject:['reload'],
        components: {
        //  QRCode,
 
        },
		// props: {
		// 	pageId: String
        // },
        data() {
			return { 
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isphone:false,
                pages:1,
                doc:'',
                islogin:false,
                userInfo:{},
                accountInfo:{},
                // link:'https://baidu.com',
                shareVisible:false,
                commentsWindow:false,
                myComment:'',
                commentList:[],
                comment_number:0,
                comment_page:1,
                comment_sort:'like',
                // comment_scrollHeight:0,
                // comment_clientHeight:0,
                // comment_scrollTop:0,
                comments_sig:true,
                weixinJDK:'',
                // downloadButton:false,
                // config: {
                //   value: 'https://baidu.com',
                //   imagePath: '/static/logo/logo.png',
                //   filter: 'color'
                // },

                mode:'',
                article_mode:0,
                ua:'',
                isMini:false,
                token:'',
                // sortItem:'最近更新',

                // squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",

                // ratecolors: ['#99A9BF', '#F7BA2A', '#FF9900'] , // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
                // value2:3,
                // search_input:'',

                 
                // articleTitle:'',
                article:{
                  title:'',
                  article_type:'请选择文章类型',
                  content:'',
                  imgs:[],
                  delete_imgs:[],
                    
                },
              
             
                i:0,  //滚轮上下监听元素
                bottom_op_onshow:false,
                bottom_op_onshow_sig:0,
                isstared:'no',
                docid:'',

                mylikes:{},
                mydislikes:{},

                scroll_timeout:'',

                docxOptions: {
                    className: "kaimo-docx-666", // string：默认和文档样式类的类名/前缀
                    inWrapper:  true, // boolean：启用围绕文档内容的包装器渲染
                    ignoreWidth: false, // boolean：禁用页面的渲染宽度
                    ignoreHeight: false, // boolean：禁止渲染页面高度
                    ignoreFonts: false, // boolean：禁用字体渲染
                    breakPages: true, // boolean：在分页符上启用分页
                    ignoreLastRenderedPageBreak: true, // boolean：在 lastRenderedPageBreak 元素上禁用分页
                    experimental: false, // boolean：启用实验功能（制表符停止计算）
                    trimXmlDeclaration: true, // boolean：如果为true，解析前会从​​ xml 文档中移除 xml 声明
                    useBase64URL: false, // boolean：如果为true，图片、字体等会转为base 64 URL，否则使用URL.createObjectURL
                    useMathMLPolyfill: false, // boolean：包括用于 chrome、edge 等的 MathML polyfill。
                    showChanges: false, // boolean：启用文档更改的实验性渲染（插入/删除）
                    debug: false, // boolean：启用额外的日志记录
                }
 
            }
        },
        created(){
          wx.miniProgram.getEnv(function(res) {
            window.console.log(res.miniprogram) // true
          })

          // window.console.log(navigator.userAgent)
        
          

 
    
   
 
          

        },
        // watch : {
        //   doc:function(){
        //     console.log('==============')
 

 

        //   }
        // },
        mounted() {
            this.getTestData()
            
            var x=document.getElementById("head_tip")
            if(x){
              x.remove(0)
            }
            // x=document.getElementById("Header")
            // if(x){
            //   x.remove(0)
            // }
            this.$emit('ChangeFunctionBox','header_onshow_off'); 

            let ua=navigator.userAgent
            let isMini=ua.indexOf("miniProgram") 
            this.us=ua
            if(isMini!=-1){
              this.isMini=true
               
            } 
            window.console.log('this.isMini:',this.isMini)

           
            this.isphone=isphone()
             


          
            window.scrollTo(0,0);
            window.addEventListener('scroll', this.handleScroll, true); 
  
            window.console.log('mounted,this.$route.params:',this.$route.params)
            






 
        },
        methods:{
          //  beforeRouteLeave(to, from, next) {
          //       // 设置下一个路由的 meta
          //       to.meta.keepAlive = true;  // B 跳转到 A 时，让 A 缓存，即不刷新
          //       next();
          //   },
          // reload () {
          //     this.isRouterAlive = false;            //先关闭，
          //     this.$nextTick(function () {
          //         this.isRouterAlive = true;         //再打开
          //     }) 
          // },

            handlePreview() {
                let file = document.getElementById("file").files[0];
                console.log(file);
                // 将file转为buffer
                let fr = new FileReader();
                fr.readAsArrayBuffer(file);
                fr.addEventListener("loadend",(e) => {
                    console.log("loadend---->", e)
                    let buffer = e.target.result;
                    this.docxRender(buffer);
                },false);
            },
            // 渲染docx
            docxRender(buffer) {
                let bodyContainer = document.getElementById("bodyContainer");
                renderAsync(
                    buffer, // Blob | ArrayBuffer | Uint8Array, 可以是 JSZip.loadAsync 支持的任何类型
                    bodyContainer, // HTMLElement 渲染文档内容的元素,
                    null, // HTMLElement, 用于呈现文档样式、数字、字体的元素。如果为 null，则将使用 bodyContainer。
                    this.docxOptions // 配置
                ).then(res => {
                    console.log("res---->", res)
                })
            },
            //1,先将base64转换为blob
            dataURLtoBlob(dataurl) {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            //2,再将blob转换为file
            blobToFile(theBlob, fileName){
                theBlob.lastModifiedDate = new Date();  // 文件最后的修改日期
                theBlob.name = fileName;                // 文件名
                return new File([theBlob], fileName, {type: theBlob.type, lastModified: Date.now()});
            },
 
         
            getTestData(){
                var that=this
                var datas= { 
                    whattodo: "getData"
                }

                
                    // {
                    //     method: 'post',
                    //     url: 'http://test.lawtip.cn/test',
                    //     data: {
                    //        whattodo: "getData"
                    //     },
                    //     responseType: 'blob'
                    // }

                this.axios.post('http://test.lawtip.cn/test',datas, 

              


                ).then(function (res) {
                    window.console.log(res)
                    // that.saving_sig=0
                    if(res.status==200){
                        let result=res.data
                        // let data=res.data
                        // console.log('data:',data)
                        // let t=dataURLtoFile(data,'abc')
                        // console.log(t)



                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){
                            let data=result.data 
                            // let a=that.dataURLtoBlob(data)
                            // console.log('a:',a)
                            // data=atob(data)
                            // // console.log('data:',data)
                            // let blob = new Blob([data],  {type: 'application/docx;charset=ascii'} );
                            // var reader = new FileReader();
                            // reader.readAsArrayBuffer(blob);//ArrayBuffer对象
                            // reader.onload = function (e) {
                            //     //读取完毕后输出结果
                            //     console.log(e.target);
                            //     that.docxRender(e.target.result)
                            // }
                            // let blob = new Blob([data],  {type: 'application/docx;charset=ascii'} );
                            // console.log('blob:',blob)
                            // let fileURL = window.URL.createObjectURL(blob)
                            //  console.log('fileURL:',fileURL)
                            // console.log('data:',data)
                            // let t=dataURLtoFile(data,'abc')
                            // console.log(t)

                            

                            // let newres=atob(data)
                            // newres=unzip(data)
                            // // let newres=unzip(data)
                            // console.log('newres:',newres)

                            // let blob = new Blob([newres],  {type: 'application/docx;charset=ascii'} );
                            // let fileURL = window.URL.createObjectURL(blob)
                            // console.log('blob:',blob)
                            // console.log('fileURL:',fileURL)
                             
                            // that.docxRender(blob)
                            
                        } else if (result.status=='fail'){
                            that.$message('失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });
            },

          BackToHome(){ 
            this.$router.push({name:'community'})
            this.$emit('ChangeFunctionBox','header_onshow_on'); 
          },
 
          Turn2Profile(){
            wx.miniProgram.navigateTo({url: '/pages/tools/intro/intro_detail?id='+this.article.userid})
          },
    
            crateQrcode () {
              this.qr = new QRCode('qrcode', {
                width: 150,
                height: 150, // 高度
                text: window.location.href // 二维码内容
                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f'
                // foreground: '#ff0'
              })
              // console.log(this.qrcode)
            },
            // 关闭弹框,清除已经生成的二维码
            closeCode () {
              this.$refs.qrcode.innerHTML = ''
            },

            errorHandler() {
                return true
            },
            
            IssueMyArticle(){
                if(this.article.title.length<2){
                  this.$message({
                    message: '标题不得少于2个字符',
                    type: 'warning'
                  });
                  return
                }
                var that=this
                var datas= { 
                  article:this.article,
                  // docid:this.article.docid,
                  whattodo: "preview_issue"
                }

                this.axios.post('https://api.lawtip.cn/article',datas
                ).then(function (res) {
                    window.console.log(res)
                    // that.saving_sig=0
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){
                            // that.$router.push({name:'article_detail',params: {mode:datas.article.docid}})
                            // that.$router.push({name:'article_detail',params: { mode:'article',id:datas.article.docid}})
                            // that.mounted()
                            // that.reload()
                            // that.$router.push({name:'article_detail',params: {mode:'article',id:that.article.docid }})
                            that.mode='article'
                            that.$message({
                              type: 'success',
                              message: '发布成功!'
                            });
                            // if(sig==1){
                           
                            // }else if(sig==0){
                            // setTimeout( ()=>{that.draftstatus='草稿'}  , 3000 )
                            // }

                            // that.article.issueTime=data.issueTime
                            // sessionStorage.setItem('my_article_draft', JSON.stringify(that.article));
                            // that.$message('保存成功');
                        } else if (result.status=='fail'){
                            that.$message('发布失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });



                


            },

       
     

 
            mouseOverItem(index){
              // window.console.log('e:',e);
              // var itemId=e.srcElement.dataset.itemId
              var itemId='file_'+index
              window.console.log('itemId:',itemId);
              // let x=document.getElementById(itemId)
              // window.console.log('x:',x);
              document.getElementById(itemId).style.color="red";
            },
            mouseLeaveItem(index){
              window.console.log('itemId:');
              var itemId='file_'+index
              document.getElementById(itemId).style.color="black";
            },


            DownLoadFile_byJs(item){
              var converted = htmlDocx.asBlob(this.doc); //,{orientation:'landscape'}           
              saveAs(converted, item.fileName);
            },

            save2docx(){
              var converted = htmlDocx.asBlob(this.doc+quill_css); //,{orientation:'landscape'}
                  // window.console.log('converted          :',this.doc+quill_css);
        
              saveAs(converted,  this.article.title+'.docx'); 
            },

            DownLoadFile(file,mode='from_server'){
              window.console.log('DownLoadFile file:',file);
              if(this.isMini){
                this.$message({
                  message: '小程序不支持下载,请访问网页版下载',
                  type: 'warning'
                });
                return
              }
             var that=this
              if(!this.islogin){
                this.$message({
                  message: '请先登录哦',
                    type: 'warning'
                  });
                  return
              }

              if(mode=='from_web'){

                that.download_web()

                // this.save2docx()
                return
              }


              let myCoins=this.$store.state.accountInfo.conis
              if(file.price){
                let price=file.price
                if(this.$store.state.accountInfo.vip==1 || this.$store.state.accountInfo.vip=='1' ){
                  price=price*0.5
                }

                this.$confirm('下载需要消耗您法币单位(会员半价)：'+price+'，是否同意？')
                .then(_ => {
                  // done();
                  that.downloading(file ,true)  //
                })
                .catch(_ => {
                  return
                });

              }else{
                that.downloading(file)
              }

 


            },

            download_web(){
              var that=this
              var datas= { 
                whattodo: "getDownLoad_web",
              }
              // datas['param']=this.param
              this.axios.post( this.$root.rootUrl+'article',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
                 
                      that.save2docx()


                    } else if (result.status=='fail'){
                      // window.console.log('get download link fail')
                      that.$message.error(result.failMsg);
                        
                    }

                }
                
              }).catch(function (error) {
                  window.console.log(error);
            
              });
            },

// getDownLoad_web

            downloading(file ,needcoin=false){
              var that=this
              var datas= { 
                whattodo: "getDownLoad",
                articleId:that.article.docid,
                fileName:file.fileName
              }
              // datas['param']=this.param
              this.axios.post( this.$root.rootUrl+'article',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
                      window.console.log('get download success')
                      // var blob = new Blob(result.link);
                      let link=result.link
                      link=link.replace("http://",'https://')

                      saveAs(link,file.fileName) 

                      // var aEle = document.createElement("a");// 创建a标签
                      // // blob = new Blob([content]); 
                      // aEle.download = fileName;// 设置下载文件的文件名
                      // //aEle.href = URL.createObjectUrl(blob);
                      // aEle.href = result.link;// content为后台返回的下载地址
                      // aEle.click();// 设置点击事件
                      if(needcoin){
                        that.refresh_coins()
                        that.$notify({
                            title: '提示',
                            message: '下载链接：'+link+'，请及时下载，链接6小时内有效',
                            type: 'success',
                            duration: 0,
                            offset:50,
                            width:100,
                            // dangerouslyUseHTMLString:true,
                            customClass: "notifycss",//自定义类名
                        });
                      }


                    } else if (result.status=='fail'){
                      // window.console.log('get download link fail')
                      that.$message.error(result.failMsg);
                        
                    }

                }
                
              }).catch(function (error) {
                  window.console.log(error);
            
              });
            },


            getCommentt_num(docid){
              var that=this
              var datas= { 
                docid:docid,
                whattodo: "get_comment_num"
              }
              this.axios.post('https://api.lawtip.cn/article_getdoc',datas
              ).then(function (res) {
                  if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                      that.$message({
                          message: '请先登录哦',
                          type: 'warning'
                      });
                    }else if (result.status=='ok'){
                      that.comment_number=result.data

                    }  

                  }

                  
                }).catch(function (error) {
                  window.console.log(error);
      
                });


            },

            Turn2Charge(){
              this.$router.push({path:'/deposit'})

            },


            refresh_coins() {
              var that=this

              console.log("this.$store.state.userInfo.userId:",this.$store.state.userInfo.userId)

              var datas= { 
                // userid: this.$store.state.userInfo.userId,
                userid:that.$root.userInfo.userId,
                whattodo:'getCoins',
              }
              this.axios.post(this.$root.rootUrl+'userinfo',datas
              ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                  var result=res.data
                  window.console.log('result:',result,'result.status:',result.status)
                  if (result.status=='ok'){
                    that.myCoins=result.coins
                    that.$root.accountInfo.coins=result.coins

                    that.$store.commit('SetNewCoins',result.coins)

                  } 
                  else if (result.status=='fail'){
                    that.$message('获取余额失败，请稍后再试');
                    
                  } 

    

               }


            
              }).catch(function (error) {
                window.console.log(error);

              });


            },



            SignIn(){
                window.console.log('SignIn')
                // this.SignInVisibl=true 
                let num= getNum()
                window.console.log('num:',num)
                var nowurl = window.location.href;
                let target=window.btoa(nowurl)
                let state=num+'(redirect)'+target
                let url='https://open.weixin.qq.com/connect/qrconnect?appid=wxe00435b975483ad0&redirect_uri=http%3a%2f%2fwww.lawtip.cn%2f%23%2flogin&response_type=code&scope=snsapi_login&state='+state+'#wechat_redirect'
                
                localStorage.setItem("loginStatus", num);
                window.open(url,"_self")


                // window.open('http://www.lawtip.cn/wenshuDetail.html?'+timestamp, '_blank')

            },

            SignOut(){
                var that=this
                window.console.log('SignOut')
                delCookie()
           
                this.islogin=false

                sessionStorage.removeItem("isLogin");
                sessionStorage.removeItem("userInfo");
                sessionStorage.removeItem("accountInfo");

               
    

                // this.$notify({
                //     title: '成功',
                //     message: '成功退出登录',
                //     type: 'success'
                // });

                this.axios.get('../PHPserver/login/SignOut.php',{
                // params: {
                //     timestamp:timestamp
                // }
                }).then(function (res) { 
                    if(res.status==200){
                        window.console.log(res.data)
                        let result=res.data
                        if(result.status=='ok'){
                            // that.$root.userInfo=result.userInfo;
                            // that.$root.accountInfo=result.accountInfo;             			
                            that.islogin=false
                            that.userInfo.avatarUrl='@/assets/images/touxiang.png'
                            // window.open('/',"_self")
                            window.open(window.location.href,"_self")
                        }        


                    }

                }).catch(function (error) {
                    window.console.log(error);
                });






                

            },

            //  qrcode () {
            //   let that = this;
            //   let qrcode = new QRCode('qrcode', {
            //       width: 124,
            //       height: 124,        // 高度
            //       text:  that.link,   // 二维码内容
            //       // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            //       // background: '#f0f',   // 背景色
            //       // foreground: '#ff0'    // 前景色
            //   })
            // }
 
 




        
        }























        

       


    }
</script>

<style >
  @import '../../../assets/css/wordpaper/sheets-of-paper-a4.css';

  [v-cloak] {
    display: none;
  }
  
  .affix{
    display: flex;
    flex-direction: column;
    width:100%;
    /* border: 1px solid #dedede; */
    margin-top:10px;
    /* padding-top:10px; */
  }
  .affix a{
    text-decoration: none;
    color:black;
  }

  .affix .firstline{
    height: 35px;
    width:100%;
    /* padding: 8px 16px; */
    
    background-color: #f1f8ff;
    line-height: 35px;
    /* padding-left:15px; */
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

 

  .affix .firstline .left{
    width:60%;
    height: 100%;
  }

  .affix .firstline .right{
    width:40%;
    height: 100%;
    justify-content: flex-end;
    padding-right: 10px; 
    font-size:14px;
 
  }


  .affix .item{
    height: 40px;
    line-height: 40px;
    width:100%;
    /* border: 1px solid #b62121; */
    /* padding-left:15px; */
    display: flex;
    flex-direction: row;
    /* align-items: center; */
    margin-top:0;
    cursor: pointer;
    overflow: hidden;

  }
  .affix .item .icon{
    width:5%;
    height: 100%;
    justify-content: center;
    align-items:center;

  } 

  .affix .item .icon img{
    width:30px;
    height:30px;
  }

  .affix .item .left{
    width:35%;
    height: 100%;
    /* border: 1px solid #dedede; */

  }  

  .affix .item .mid{
    width:40%;
    height: 100%;
    /* border: 1px solid #dedede; */

  }  

  .affix .item .right{
    width:20%;
    height: 100%;
    justify-content: flex-end;
    padding-right:10px;

    /* border: 1px solid #bdbcbc; */
    display: flex;
    flex-direction: row;
    align-items: center;
  }  
  /* .affix .item .right button{
    height:70%;
  } */

.fileUpdateTime{
  margin:auto;
  font-size:12px;
  color:#9c9c9c;
}


  .editor_wrap{
   
    display: flex;
    flex-direction: column;
    /* border: 1px solid #333;  */
    /* justify-content: flex-start; */
  }

  .sharecode{
    /* border: 1px solid #d64545;  */
    margin:auto;
    /* margin-bottom:15px; */
  }
 

  .header_{
    width:100%;
    min-height: 55px;
    /* height: 55px; */
 
    border-bottom: 1px solid #e7e7e7; 
    display: flex;
    flex-direction: row;
  
 
    color:black;
    align-items: center;

  }

  .head_operation{
    width:40%;
    display: flex;
    flex-direction: row;
    /* border: 1px solid #ad3131;  */
    justify-content: flex-end;
    align-items:center;
    height: 100%;
    font-size:24px;
    padding-right: 15px;
  }

  .loginAvatar{
    width:10%;
    justify-content: flex-end;
    display: flex;
    flex-direction: row;
    align-items:center;
    text-align: right;
    height: 100%;
    /* border: 1px solid #ad3131;  */

  }

  .head_operation i{
    margin-left:50px;
    cursor: pointer;
  }

  .button_head{
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
 
  .middle{
    display: flex;
    flex-direction: row;
    /* padding-top:15px ;
    border: 1px solid rgb(185, 19, 19);  */
    /* margin-top: 55px; */
  }

  .left ,.right{
    width:18%;
    /* border: 1px solid rgb(19, 40, 156);  */

  }
  .mid_{
    display: flex;
    flex-direction: column;
    width:64%;
    /* border: 1px solid rgb(211, 233, 14);  */
    /* flex-wrap: wrap; */
    word-wrap:break-word;
    word-break:break-all;

  }

  .starBar{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 40px;
    /* border: 1px solid rgb(211, 233, 14);   */
    justify-content: flex-end;
    align-items: center;
    line-height: 40px;
    /* position: relative; */

  }

  .starbox{
    border: 1px solid #c8e1ff;
    height: 80%;
    width:100%;
    margin-top:auto;
    margin-bottom: auto;
 
 
  }
  .starlikesnum{
    /* border-left: 1px solid #c8e1ff; */
    width:30%;
    height: 100%;
    font-size:22px;

  }
  .starBar .op{
    
    min-width:100px;
    height: 100%;
    /* border: 1px solid rgb(33, 88, 189);  */
    /* line-height: 60px; */
    /* padding: 5px; */
    cursor: pointer;
    /* float:right; */
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left:10px;
    justify-content: center;
   
 
  }

   .starBar .op button{
     height: 70%;
   }


  
 
/* 
  .el-icon-star-on,.el-icon-star-off{
    line-height: auto;
 
    height: 100%;
    width:100%;
    border: 1px solid rgb(8, 22, 48);
  } */

  /* .mid p{
    overflow: wrap;
  } */

  /* .divcontent{
    border: 1px solid rgb(211, 233, 14); 
    width:100%;
 
  } */
/* 
  .divcontent .img{
    
  } */
/* 
  .mid img{

    max-width:100%;
  } */

  .mid >>>  img{
    max-width:100%;
    display: block;
    margin:auto;
  }
  .mid >>> pre{
    background-color:#e9e8e8;
    overflow:scroll;
  }

  .contract_title{
    /* display: flex;
    flex-wrap: wrap; */
    min-height: 50px;
    width: 100%;
    line-height: 50px;
    font-size:30px;
    font-weight: normal;
  
    /* border: 1px solid rgb(211, 233, 14); */
  }
  .author{
    height: 50px;
    width:100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bottom{
    text-align: center;
    font-size: 12px;
  }

  .editor_class{
     height: 90%;
  }


  .bottom_op{
    height:60px;
    width:100%;
    /* border: 1px solid rgb(211, 233, 14);  */
    position:fixed;
    bottom:0;
    background-color: #fff;
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content: center;
    box-shadow:1.5px 1.5px 5px #909090;
   
  }
  .bottom_op_item{
    width:130px;
    height: 100%;
    /* border: 1px solid rgb(211, 233, 14);  */
    line-height: 60px;
    padding-left: 15px;
    cursor: pointer;
  }
  .bottom_op_icon{
    /* margin-left:45px; */
    /* line-height: 30px; */
    font-size:17px;
    font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
    color:#646464;
    cursor: pointer;
   
  }

  .html_content{
    /* border: 1px solid rgb(211, 233, 14); */
    /* padding-left:8px;
    padding-right:8px; */
  }

  .tagsBar{margin-top:25px}
  .tagsBar span{
    margin-right:20px;
  }
 

  /* .bottom_op_font{
    margin-left:5px;
    cursor: pointer;
    font-size:16px;
   
  } */

  .comments_box{

    /* display: flex;
    flex-direction: column; */
    /* border: 1px solid rgb(211, 233, 14); */
    width:100%;
    height:500px;
    overflow-y: scroll;
    /* width:100%;
    height: 100%; */


  }

  .comments_box .titleBar{
    width:90%;
    height: 50px;
    /* border: 1px solid rgb(16, 160, 148); */
    position:absolute;
    top:5px;
    display: flex;
    flex-direction: row;
    align-items:center;

  }

   .comments_box .titleBar .comment_num{
    width:65%;
    /* border: 1px solid rgb(16, 160, 148); */
    height: 100%;
    line-height: 50px;
    font-size:20px;

   }
  .comments_box .sortbar{
    float:right;
    width:30%;
    height: 30px;
    /* border: 1px solid rgb(16, 160, 148); */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items:center;
    margin-bottom: 5px;
    ;
    
  }

   .comments_box .sortbar span{
    cursor: pointer;
   }

  .comments_box .sortbar img {
    margin-right: 15px;
  }

  .inputComment{

    /* position: absolute;
    bottom: 5px; */
    /* border: 1px solid  #a3a3a3; */
    width:100%;
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    align-items:center;

  }

  /* .inputComment el-input{
    width:80%;
  } */
  



  
    .comment_box{
        border-bottom:1px solid #dedede;
        width:95%;
        min-height: 150px;
        margin-right: auto;
        margin-left:auto;
        margin-top:15px;
        display: flex;
        flex-direction: column;

    }

 
    .comment_box_up{
        height:22%;
        width:100%;
        /* border:1px solid #2c232a; */
        display: flex;
        flex-direction: row;
        align-items:center;
    }
 

    .comment_box_down{
        height:72%;
        width:100%;
        /* border:1px solid #39a32f; */
        display: flex;
        flex-direction: row;

    }

    .comment_card{
        width: 100%;
        border:1px solid #dedede;

    }
    .title_comment{
      cursor: pointer; 
      /* border:1px solid #7a0202; */
      min-height: 25px;
      line-height: 25px;
      
    }
    .title_comment, .mid_comment, .bottom_comment{
        margin-bottom: 15px;
    }

    .title_comment .doclink{
        text-decoration: none;
        color:black;
    }

    .mid_comment{
        /* font-weight: lighter; */
        font-size: 14px;
        color:#aaa9a9;
    }
    .bottom_comment{
        font-size:12px;
        color:#aaa9a9;
    }
    .bottom_comment span{
        margin-right: 12px;
    }


    .comment_box_down.left{
        width:5%;
        height: 100%;
    }
    .comment_box_down.right{
        width:95%;
        height: 100%;

        /* border: #757575; */
    }


  .op_comment{
    font-size:14px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .op_comment span {
    margin-right:20px;
    /* color:#b8b6b6; */
    cursor: pointer;
  }











  

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px"!important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px"!important;;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px"!important;;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px" !important;;
}




.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本" !important;;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5" !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6" !important;
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
 











@font-face {
  font-family: 'iconfont';  /* project id 1697282 */
  src: url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.eot');
  src: url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.woff') format('woff'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1697282_rxiq9v1joy.svg#iconfont') format('svg');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* .icon-shanchu:before {
  content: "\e625";
}

.icon-praise:before {
  content: "\e501";
}

.icon-shoucang-copy:before {
  content: "\e52a";
}

.icon-fenxiangdaozhuanfafasongzhiyuanquanmianxing:before {
  content: "\e921";
}

.icon-zan:before {
  content: "\e509";
}

.icon-nolove:before {
  content: "\e508";
}

.icon-dianzan:before {
  content: "\e50f";
}

.icon-dianzan11-copy:before {
  content: "\e50a";
}

.icon-fenxiang:before {
  content: "\e606";
}

.icon-shanchu1:before {
  content: "\e603";
}

.icon-shoucang:before {
  content: "\e504";
} */

.ql-align-center{
  text-align: center;
}


.notifycss {
  /* white-space:pre-wrap !important;  */
  /* word-wrap: break-word; */
  word-break: break-all;
  /* height: auto;
  border: 1px solid #db1a1a;  */
 }

/* .el-notification .notifycss  {
   word-break: break-all;
} */
 
  
 

.hideimg{
  /* width: 100%; */
  height: 95%;
  position: absolute;
  /* object-fit:cover; */
  vertical-align:middle;
  z-index: 999;
  opacity: 0.1;
   -webkit-user-drag: none;
  /* border: 4px solid #db1a1a;  */
}
 

 
   
</style>
